import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrPartnerWebhookEventType.ts
var t = () => e("partnerWebhookEventType");
//#endregion
export { t as useTrPartnerWebhookEventType };
